// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NcBi","toggle":"styles_toggle__2kY3P","preview":"styles_preview__31yaY"};